require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-winden-am-see.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-winden-am-see");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-winden-am-see!./.cache/json/betreuungseinrichtungen-neusiedl-winden-am-see.json
// module id = 968
// module chunks = 231608221292675